import React, { useEffect } from 'react';
import styles from '../css/Recuerdos.module.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const DelRecuerdo = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000, once: true });
    }, []);

    const videosRecuerdo = [
        { id: "q8C7b5Hy5Ac", titulo: "Predicación de Nuestro Pastor Ramón en Gomez Carreño", fecha: "2009" },
        { id: "dyv9CrrwoiQ", titulo: "Conmemoración 50 años de pastorado Pr Ramón López y Pra Guillermina Navarro", fecha: "Recuerdo" },
        { id: "6qBJngsPnqQ", titulo: "Predicación del Pastor Ramón Lopez en el marco de la semana de consagración de la IUMP Glorias Navales", fecha: "2017 - Eternidad Records" },
        { id: "NtV4mNWhZpg", titulo: "Alabanza interpretada por el coro regional V region en el marco de la asamblea anual de pastores y delegados celebrada en Viña del Mar", fecha: "2006 - Eternidad Records" },
        { id: "V6A1NEkUOIQ", titulo: "Alabanza 'Correr correr' interpretada por el coro regional de la V region en el marco de la asamblea anual de pastores en Viña del mar.", fecha: "2006 - Eternidad Records" },
        { id: "minMBmpJHL4", titulo: "Alabanzas Iglesia Unida Metodista Pentecostal", fecha: "1993 - Eternidad Records" },
        { id: "QIUJ5t1svg8", titulo: "Alabanza escrita e interpretada por el Pastor Raul Alvarado Granja para su padre Raul Alvarado Tapia", fecha: "Recuerdo - Eternidad Records" },
        { id: "PAD8ENah8P0", titulo: "Tedeum año 2008 realizado en la 1ª Iglesia Unida Metodista Pentecostal de Viña del Mar, con la presencia de altas autoridades civiles, militares y eclesiásticas", fecha: "2008 - Eternidad Records" },
        { id: "-GooRJBln7s", titulo: "Disco tiempo de Alabar - Hna Carla López", fecha: "Recuerdo - Eternidad Records" },
        { id: "j2nF-Pm5-Ps", titulo: "Alabanza Hermano, dinos hoy", fecha: "1999 - Eternidad Records" },
        { id: "iVKu2bHTsvw", titulo: "Autor: Pastor Raul Alvarado Tapia. | Tema : Gracias Señor | Alabanza dedicadas a las pastoras.", fecha: "Recuerdo - Eternidad Records" },
        { id: "EAvS2Q-IF2Q", titulo: "Disco 'Jesus, tu eres especial' . Pastor Raul alvarado Tapia", fecha: "1997 - Eternidad Records" },
        { id: "9qtYOuIzDKg", titulo: "Rev. Obispo Carlos san Martin Pulgar.", fecha: "1998 - Eternidad Records" },
        { id: "RwFZOHyc6zk", titulo: "Alabanza 'En horas tristes' Interpretada por el en ese entonces hermano Raul Alvarado Granja", fecha: "2006 - Eternidad Records" },
        { id: "xRZAO23h5Jw", titulo: "Conferencia anual realizada en Viña del Mar.", fecha: "2006 - Eternidad Records" },
        { id: "cbIcFoP0f5A", titulo: "38 Asamblea Semestral de Pastores y Supervisores Iglesia Unida Metodista Pentecostal Con Con.", fecha: "Recuerdo" },
    ];

    return (
        <div className={styles.container}>
            {/* Decoración de fondo */}
            <div className={styles.bgDecorations}>
                <div className={styles.overlay}></div>
            </div>

            <section 
                className={styles.hero}
                style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.6)), url('/historia_1988.jpg')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundAttachment: 'fixed'
                }}
            >
                <div className={styles.heroContent} data-aos="fade-down">
                    <span className={styles.preTitle}>Archivo Histórico</span>
                    <h1 className={styles.mainTitle}>Del Recuerdo</h1>
                    <div className={styles.goldDivider}></div>
                    <p className={styles.quote}>"Trayectoria y momentos que marcaron nuestra fe"</p>
                </div>
            </section>

            <main className={styles.content}>
                <div className={styles.videoGrid}>
                    {videosRecuerdo.map((video, index) => (
                        <div 
                            className={styles.videoCard} 
                            key={index} 
                            data-aos="fade-up"
                            data-aos-delay={index % 3 * 100}
                        >
                            <div className={styles.videoWrapper}>
                                <iframe
                                    src={`https://www.youtube.com/embed/${video.id}`}
                                    title={video.titulo}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            <div className={styles.videoInfo}>
                                <span className={styles.dateBadge}>{video.fecha}</span>
                                <h3>{video.titulo}</h3>
                                <div className={styles.playIcon}>
                                    <i className="fab fa-youtube"></i> Reproducir ahora
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </main>
            <br /><br /><br />
        </div>
    );
};

export default DelRecuerdo;